import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cn from 'classnames';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { linkPropertiesType } from '../propTypes';
import get from '../helpers/get';
import { trackEventCreator, trackImpressionEventCreator } from '../actions';
import { linkHasTracking } from '../selectors';
import useElementVisible from '../hooks/useElementVisible';

const mapDispatchToProps = (dispatch, { link, onClick }) => ({
  onClick(...args) {
    if (linkHasTracking(link)) {
      dispatch(trackEventCreator(link));
    }
    return onClick && onClick.call(this, ...args);
  },
  onVisible() {
    if (linkHasTracking(link)) {
      dispatch(trackImpressionEventCreator(link));
    }
  },
});

export default function withGtm(WrappedComponent) {
  const WithGtmOnClick = ({
    className, link, onVisible, ...rest
  }) => {
    const [containerRef, isVisible] = useElementVisible({
      root: null,
      rootMargin: '0px',
      threshold: 0.5,
    });
    return (
      <>
        <WrappedComponent
          className={cn(className, get(link, ['gtm', 'class']))}
          link={link}
          {...rest}
        />
        <div
          ref={containerRef}
        >
          { isVisible && onVisible() }
        </div>
      </>
    );
  };

  WithGtmOnClick.propTypes = {
    className: PropTypes.string,
    link: linkPropertiesType,
    onVisible: PropTypes.func.isRequired,
  };

  WithGtmOnClick.defaultProps = {
    className: undefined,
    link: undefined,
  };

  return connect(undefined, mapDispatchToProps)(
    hoistNonReactStatics(WithGtmOnClick, WrappedComponent),
  );
}
